"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { useSeizeConnectContext } from "../auth/SeizeConnectContext";
import Notifications from "../brain/notifications";
import { ActiveDropState } from "../../types/dropInteractionTypes";
import BrainContent from "../brain/content/BrainContent";
import { useDropModal } from "@/hooks/useDropModal";
import BrainDesktopDrop from "@/components/brain/BrainDesktopDrop";
import { DropSize } from "@/helpers/waves/drop.helpers";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { useLayout } from "@/components/brain/my-stream/layout/LayoutContext";
import ConnectWallet from "@/components/common/ConnectWallet";
export default function NotificationsPage() {
  const $ = _c(16);
  const {
    isAuthenticated
  } = useSeizeConnectContext();
  const [activeDrop, setActiveDrop] = useState(null);
  const {
    drop,
    isDropOpen,
    onDropClose
  } = useDropModal();
  const {
    isApp
  } = useDeviceInfo();
  const {
    spaces
  } = useLayout();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setActiveDrop(null);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const onCancelReplyQuote = t0;
  if (!isAuthenticated) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ConnectWallet />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== drop || $[3] !== isApp || $[4] !== isDropOpen || $[5] !== onDropClose || $[6] !== spaces) {
    t1 = isDropOpen && drop && (isApp ? <div className="tw-fixed tw-inset-x-0 tw-bottom-0 tw-z-[1000]" style={{
      top: spaces.headerSpace
    }}><BrainDesktopDrop drop={{
        type: DropSize.FULL,
        ...drop,
        stableKey: drop.id,
        stableHash: drop.id
      }} onClose={onDropClose} /></div> : <div className="tw-absolute tw-inset-0 tw-z-[49]"><BrainDesktopDrop drop={{
        type: DropSize.FULL,
        ...drop,
        stableKey: drop.id,
        stableHash: drop.id
      }} onClose={onDropClose} /></div>);
    $[2] = drop;
    $[3] = isApp;
    $[4] = isDropOpen;
    $[5] = onDropClose;
    $[6] = spaces;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== activeDrop) {
    t2 = <Notifications activeDrop={activeDrop} setActiveDrop={setActiveDrop} />;
    $[8] = activeDrop;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== activeDrop || $[11] !== t2) {
    t3 = <div className="tw-h-full tw-px-2 lg:tw-px-6 xl:tw-px-8"><BrainContent activeDrop={activeDrop} onCancelReplyQuote={onCancelReplyQuote} showPinnedWaves={false}>{t2}</BrainContent></div>;
    $[10] = activeDrop;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t1 || $[14] !== t3) {
    t4 = <div className="tw-h-full tw-bg-black tailwind-scope tw-relative">{t1}{t3}</div>;
    $[13] = t1;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}